// extracted by mini-css-extract-plugin
module.exports = {"webviewMarginTop":"tabcustom_webviewMarginTop__Snp9q","webview":"tabcustom_webview__zwhHe"};